import {Injectable, Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'filterWsUsage'
})
@Injectable()
export class WsUsageFIlter implements PipeTransform {
  transform(data: any[], searchVal: string): any {
    return data.filter(row => row.name.toLowerCase().indexOf(searchVal.toLowerCase()) !== -1);
  }
}